import React from 'react';
import { useApprovals } from '../../approvals/useData';
import { StatusBreakdown } from './shared';
import type { StatusBreakdownRow } from './shared';

const ApprovalsByStatus: React.FC<{ embedded?: boolean }> = ({ embedded }) => {
  const { total: pendingTotal, isLoading: pendingLoading } = useApprovals('all', 1, '', {
    status: 'PENDING',
  });
  const { total: approvedTotal, isLoading: approvedLoading } = useApprovals('all', 1, '', {
    status: 'APPROVED',
  });
  const { total: rejectedTotal, isLoading: rejectedLoading } = useApprovals('all', 1, '', {
    status: 'REJECTED',
  });
  const { total: draftTotal, isLoading: draftLoading } = useApprovals('all', 1, '', {
    status: 'DRAFT',
  });

  const isLoading = pendingLoading || approvedLoading || rejectedLoading || draftLoading;

  const rows: StatusBreakdownRow[] = [
    { key: 'pending', label: 'Pending', value: pendingTotal ?? 0, color: 'bg-amber-500' },
    { key: 'approved', label: 'Approved', value: approvedTotal ?? 0, color: 'bg-emerald-500' },
    { key: 'rejected', label: 'Rejected', value: rejectedTotal ?? 0, color: 'bg-rose-500' },
    { key: 'draft', label: 'Draft', value: draftTotal ?? 0, color: 'bg-slate-500' },
  ];

  return (
    <StatusBreakdown
      title="Approvals · By Status"
      rows={rows}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/approvals"
      emptyMessage="No approvals"
    />
  );
};

export default ApprovalsByStatus;
